<template functional>
  <div class="flex flex-col">
    <router-link
      v-if="!props.column.meta.isCarClosed"
      :to="`/legacy/provision_edit/${props.row.item_provision}`"
      class="hover:underline"
      v-text="props.row.item_provision_name"
    />
    <span
      v-else
      v-text="props.row.item_provision_name"
    />

    <span class="text-sm text-gray-800">
      Verkäufer: <span
        v-if="!props.row.item_seller_userid"
        class="text-orange-mia-dark font-bold"
      >Carana</span><router-link
        v-else
        :to="`/user/profile/${props.row.item_seller_userid}`"
        class="hover:underline"
        v-text="props.row.item_seller_lastname || 'Unbekannt'"
      />
    </span>

    <p
      class="mt-1 mb-0 text-sm italic"
      v-text="props.row.item_comment"
    />
  </div>
</template>

<script>
export default {
  name: 'MiaCarProvisionAccountingInfoDatatableColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
